import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { HelpCircle } from "lucide-react";

const faqs = [
  {
    question: "Wie viel Geld bekommt man für Plasmaspenden in Deutschland?",
    answer:
      "Die Aufwandsentschädigung liegt gewöhnlich bei ca. 30 Euro pro Spende und wird immer direkt vor Ort im Plasmazentrum bar ausgezahlt. Durch Treuestaffeln, Sonderaktionen und Neuspender-Boni ist zusätzlich mehr möglich, sodass bei regelmäßigen Spenden ein attraktiver monatlicher Zusatzverdienst zusammenkommt.",
  },
  {
    question: "Wie viel Geld bekommt man bei CSL Plasma pro Spende?",
    answer:
      "Bei CSL Plasma erhalten Sie gewöhnlich ca. 30 Euro Aufwandsentschädigung pro Spende, die immer sofort nach dem Termin in bar ausgezahlt wird. Zusätzlich bietet CSL Plasma regelmäßige Aktionen und Treueboni. Als Neuspender erhalten Sie über die ersten 10 Spenden verteilt bis zu 150 Euro Anmeldebonus (25 € bei der 3., 50 € bei der 6. und 75 € bei der 10. Spende).",
  },
  {
    question: "Welche Aktionen und Bonusprogramme gibt es für Neuspender?",
    answer:
      "Sowohl CSL Plasma als auch Plasma Service Europe (PSE) bieten lukrative Neuspender-Aktionen: Bei CSL Plasma winken bis zu 150 Euro Anmeldebonus (25 € nach der 3., 50 € nach der 6. und 75 € nach der 10. Spende). Bei Plasma Service Europe gibt es bis zu 100 Euro Anmeldebonus (je 25 € nach der 2., 4., 6. und 10. Spende). Alle Aufwandsentschädigungen und Boni werden bar im Zentrum ausgezahlt. Wichtig ist, bei der Erstanmeldung die jeweilige Spendernummer anzugeben.",
  },
  {
    question: "Wie oft darf man Plasma spenden?",
    answer:
      "Innerhalb von zwölf Monaten sind bis zu 60 Plasmaspenden möglich; zwischen zwei Spenden müssen mindestens zwei Kalendertage liegen. Die tatsächlich mögliche Häufigkeit hängt unter anderem von der individuellen Regeneration der Proteine und der ärztlichen Beurteilung ab. Wenn Sie zusätzlich Vollblut spenden, können andere Abstände gelten.",
    source: {
      href: "https://www.blutspenden.de/faq",
      label: "BIÖG: FAQ zur Plasmaspende",
    },
  },
  {
    question: "Ist Plasmaspenden sicher?",
    answer:
      "Vor jeder Spende wird geprüft, ob Sie aktuell spenden können. Dabei berücksichtigt das medizinische Personal Ihre Angaben und Untersuchungsergebnisse. Wie bei medizinischen Verfahren können Beschwerden auftreten; sprechen Sie Fragen zu persönlichen Risiken vor der Spende mit dem Ärzteteam im Zentrum ab.",
    source: {
      href: "https://www.blutspenden.de/blut-und-plasmaspende/voraussetzungen-fuer-eine-blut-oder-plasmaspende/",
      label: "BIÖG: Voraussetzungen und Prüfung vor jeder Spende",
    },
  },
  {
    question: "Wie lange dauert eine Plasmaspende?",
    answer:
      "Die reine Spende dauert laut Anbieterangaben bei CSL Plasma etwa 30–45 Minuten und bei Plasma Service Europe etwa 30–55 Minuten. Für den regulären Besuch kommt Zeit für Anmeldung, ärztliche Untersuchung und Erholung hinzu: Das BIÖG nennt dafür zusätzlich etwa 30 Minuten; PSE empfiehlt insgesamt mindestens eine Stunde. Der Erstbesuch dauert länger, weil Aufnahme, Untersuchung und Blutprobe dazukommen. Bei CSL kann die erste Spende laut Anbieterangabe nach etwa drei Tagen erfolgen; bei PSE dauert die Laboruntersuchung der Erstprobe etwa sieben Tage. Die erste Spende findet daher gegebenenfalls an einem späteren Termin statt.",
    source: {
      href: "https://www.blutspenden.de/faq",
      label: "BIÖG: FAQ zur Dauer der Plasmaspende",
    },
  },
  {
    question: "Was ist der Unterschied zwischen Blutspende und Plasmaspende?",
    answer:
      "Bei der Blutspende wird Vollblut entnommen. Bei der Plasmaspende wird Plasma gewonnen und die übrigen Blutbestandteile werden zurückgeführt. Deshalb sind bei Plasmaspenden kürzere Abstände möglich: bis zu 60 Spenden innerhalb von zwölf Monaten, sofern die individuelle Eignung gegeben ist.",
  },
  {
    question: "Welche Voraussetzungen muss ich für eine Plasmaspende erfüllen?",
    answer:
      "Als grundlegende Kriterien gelten ein Mindestalter von 18 Jahren und mindestens 50 kg Körpergewicht. Eine allgemeine Höchstaltersgrenze gibt es nicht; ob eine Spende möglich ist, beurteilt das Ärzteteam individuell und vor jeder Spende. Auch Gesundheitszustand, Untersuchungsergebnisse und weitere persönliche Umstände spielen eine Rolle. Welche Ausweisdokumente benötigt werden, kann je nach Zentrum variieren.",
    source: {
      href: "https://www.blutspenden.de/blut-und-plasmaspende/voraussetzungen-fuer-eine-blut-oder-plasmaspende/",
      label: "BIÖG: Voraussetzungen für eine Blut- oder Plasmaspende",
    },
  },
  {
    question: "Wo kann ich in Deutschland Plasma spenden?",
    answer:
      "CSL Plasma führt unter anderem Standorte in Berlin, Bremen, Hamburg, Köln und Wiesbaden. Plasma Service Europe betreibt 14 Zentren in 13 Städten, darunter zwei Zentren in Köln. Die Adressen finden Sie in unserer Standortübersicht; bitte prüfen Sie Öffnungszeiten und Verfügbarkeit vor Ihrem Besuch direkt beim Anbieter.",
  },
  {
    question: "Was muss ich vor der Plasmaspende beachten?",
    answer:
      "Trinken Sie am Spendetag mindestens 2 Liter Wasser. Essen Sie eine leichte, fettarme Mahlzeit vor der Spende. Vermeiden Sie am Vortag fettreiche Speisen und Alkohol. Bringen Sie einen gültigen Ausweis mit und vergessen Sie nicht, bei der Erstanmeldung Ihre Spendernummer für den Bonus anzugeben.",
  },
  {
    question: "Welche Nebenwirkungen kann eine Plasmaspende haben?",
    answer:
      "Mögliche Beschwerden können zum Beispiel Schwindel, Kreislaufreaktionen oder ein Bluterguss an der Einstichstelle sein. Reaktionen und Verlauf sind individuell. Informieren Sie das Personal sofort, wenn Sie sich während oder nach der Spende unwohl fühlen; bei anhaltenden oder starken Beschwerden holen Sie medizinischen Rat ein.",
    source: {
      href: "https://www.hhs.gov/oidp/focus-areas/blood-tissue-safety/giving-plasma/index.html",
      label: "U.S. Department of Health and Human Services: Plasma donation",
    },
  },
  {
    question: "Wofür wird mein gespendetes Plasma verwendet?",
    answer:
      "Plasma wird unter anderem für Arzneimittel verwendet, die bei primären Immundefekten und Blutgerinnungsstörungen eingesetzt werden. Welche Produkte daraus entstehen und wofür sie zugelassen sind, hängt vom jeweiligen Präparat ab.",
    source: {
      href: "https://www.blutspenden.de/faq",
      label: "BIÖG: Verwendung von Blutplasmaspenden",
    },
  },
  {
    question: "Kann ich mit Tattoo oder Piercing Plasma spenden?",
    answer:
      "Nach einer Tätowierung gilt laut BIÖG eine Rückstellungsfrist von vier Monaten. Für Piercings oder besondere Umstände können gesonderte Regeln gelten. Informieren Sie das Zentrum vorab und lassen Sie die individuelle Frist dort prüfen.",
    source: {
      href: "https://www.blutspenden.de/blut-und-plasmaspende/rueckstellung-und-ausschluss/",
      label: "BIÖG: Rückstellung und Ausschluss",
    },
  },
  {
    question: "Muss ich einen Termin vereinbaren?",
    answer:
      "Bei den meisten Plasmazentren können Sie sowohl mit als auch ohne Termin vorbeikommen. Eine Terminvereinbarung ist jedoch empfehlenswert, da Sie so Wartezeiten vermeiden können. Termine können online, telefonisch oder über die Apps der Anbieter gebucht werden.",
  },
];

const FAQ = () => {
  return (
    <section
      className="section-padding bg-muted/30 py-16 md:py-20 scroll-mt-20 md:scroll-mt-0"
      id="faq"
      aria-labelledby="faq-heading"
    >
      <div className="container container-narrow">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 glass-card rounded-full px-5 py-2.5 mb-6">
            <HelpCircle className="w-4 h-4 text-primary" />
            <span className="text-sm font-semibold text-foreground">
              Häufige Fragen
            </span>
          </div>

          <h2
            id="faq-heading"
            className="text-3xl md:text-4xl font-bold mb-4 font-display"
          >
            <span className="text-foreground">FAQ: Alles über </span>
            <span className="text-gradient">Plasmaspenden</span>
          </h2>
          <p className="text-muted-foreground max-w-xl mx-auto text-lg">
            Antworten auf die wichtigsten Fragen rund um die Plasmaspende in
            Deutschland
          </p>
        </div>

        <div className="card-modern overflow-hidden glow-primary">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="border-b border-border last:border-b-0"
              >
                <AccordionTrigger className="px-6 py-5 text-left hover:no-underline hover:bg-muted/30 transition-colors group">
                  <span className="font-semibold text-foreground pr-4 group-hover:text-primary transition-colors">
                    {faq.question}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="px-6 pb-5 text-muted-foreground leading-relaxed">
                  {faq.answer}
                  {"source" in faq && faq.source && (
                    <p className="text-xs mt-3">
                      Quelle: {" "}
                      <a
                        href={faq.source.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="underline underline-offset-2 hover:text-foreground"
                      >
                        {faq.source.label}
                      </a>
                    </p>
                  )}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        {/* Schema.org FAQ structured data */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "FAQPage",
              mainEntity: faqs.map((faq) => ({
                "@type": "Question",
                name: faq.question,
                acceptedAnswer: {
                  "@type": "Answer",
                  text: faq.answer,
                },
              })),
            }),
          }}
        />
      </div>
    </section>
  );
};

export default FAQ;
